import { mainStore } from '../../store'

import auth from '../../services/auth.service'
import variables from '../../variables'

const beforeActiveRoutes = ['account-activation']

export default {
    ifNotAuthenticated: async (to, from, next) => {
        const store = mainStore()

        if (!auth.getOnLocalStorage('token')) {
            next()
            return
        } else {
            if (store.user.active) {
                next('/painel')
                return
            }
            next('/account-activation')
        }
    },

    ifAuthenticated: async (to, from, next) => {
        const store = mainStore()

        if (auth.getOnLocalStorage('token')) {
            const notActive = !store.user.active && !beforeActiveRoutes.includes(to.name)

            if (notActive) {
                next('/account-activation')
                return
            }

            next()
            return
        }
        next('/login')
    },

    ifAuthenticatedOrNot: (to, from, next) => {
        const store = mainStore()

        const urlSearchParams = new URLSearchParams(window.location.search)
        const token = urlSearchParams.get('token')

        if (auth.getOnLocalStorage('token') && !token) {
            next()
            return
        } else if (token) {
            store.LOGOUT()
            auth.clearLocalStorage()
            auth.saveOnLocalStorage('token', token)
            next()
            return
        }
        next('/login')
    },

    ifRouteIsUnLocked: (to, from, next) => {
        const { lockBankConnection, hideSubscreenProfile } = variables

        switch (to.name) {
            case 'bankaccess':
            case 'bankaccess_sync':
                if (lockBankConnection) next('/configuracoes')
                else next()
            case 'perfil':
                if (hideSubscreenProfile) next('/configuracoes/categorias')
                else next()
            default:
                next()
        }
    },
}
